import styled from 'styled-components';

//components
import $ResponsiveFontSize from 'components/ResponsiveFontSize';

//helpers
import {getFormattedTextStyle} from 'styles/formatted-text';

const FormattedText = styled.div`
  ${p => getFormattedTextStyle(p.isCompact)};
  p:empty {
    height: 1em;
  }
`;

export const StyledResponsiveFontSize = FormattedText.withComponent($ResponsiveFontSize);

export const FixedFontSize = styled(FormattedText)`
  font-size: ${p => (p.device === 'desktop' ? 1 : 0.75)}rem;
`;
